export default __webpack_public_path__ + "static/media/logo.010c47cd.png";